import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { setDialog } from '../store/actions/dialog'
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  Typography
} from '@material-ui/core'

import { makeStyles, Theme } from '@material-ui/core/styles'

import Title from '../components/atoms/Title'
import store from '../store'
import { Admin } from '../types/Admin'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflowY: 'hidden',
    flexDirection: 'column',
    height: `100%`
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalPaper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  avatar: {
    width: 60,
    height: 60
  }
}))

const Admins: React.FC<ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>> =
  ({ admin, setDialog }) => {
    const classes = useStyles({})
    const [admins, setAdmins] = useState<Admin[]>([])
    const loginAdmin = admin

    useEffect(() => {
      const fetchData = async () => {
        const { data } = await axios.get<Admin[]>('/admins')
        setAdmins(data)
      }
      fetchData()
    }, [])

    const handleToggleInvalid = async (adminId: number, checked: boolean) => {
      try {
        const { data } = await axios.put<Admin>(`/admins/${adminId}`, {
          invalid_flg: checked
        })
        const _admins = admins.slice()
        admins.forEach((admin, index) => {
          if (admin.id === adminId) {
            _admins[index] = data
          }
        })
        setAdmins(_admins)
      } catch (error) {
        alert(error.message)
      }
    }
    const handleDelete = async (adminId: number) => {
      setDialog(
        '確認',
        '削除してもよろしいですか？',
        async () => {
          await axios.delete(`/admins/${adminId}`)
          const { data } = await axios.get<Admin[]>('/admins')
          setAdmins(data)
        },
        () => {}
      )
    }

    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Title>設定</Title>
            <Typography paragraph>admin権限では他のアカウントの編集ができます。</Typography>
            <Typography paragraph>
              admin権限アカウントは削除できません。general権限に変更してから削除してください。
            </Typography>
            <Box mt={5} mb={5}>
              <Button variant="contained" color="primary" href="/create-admin">
                管理者の新規作成
              </Button>
            </Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>表示名</TableCell>
                  <TableCell>ログインID</TableCell>
                  <TableCell>権限</TableCell>
                  <TableCell>E-mail</TableCell>
                  <TableCell align="center">有効/無効</TableCell>
                  <TableCell align="center">編集</TableCell>
                  <TableCell align="center">削除</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {admins.map((admin, index) => (
                  <TableRow key={admin.id}>
                    <TableCell align="left">{admin.name}</TableCell>
                    <TableCell align="left">{admin.admin_id}</TableCell>
                    <TableCell align="left">{admin.roles}</TableCell>
                    <TableCell align="left">{admin.email}</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color={!Boolean(admin.invalid_flg) ? 'primary' : 'default'}
                        onClick={() => handleToggleInvalid(admin.id, !admin.invalid_flg)}
                      >
                        {!Boolean(admin.invalid_flg) ? '有効' : '無効'}
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button variant="contained" color="primary" href={`/edit-admin/${admin.id}`}>
                        編集
                      </Button>
                    </TableCell>
                    {admin.roles !== 'admin' && loginAdmin.id !== admin.id ? (
                      <TableCell align="center" onClick={() => handleDelete(admin.id)}>
                        <Button variant="contained" color="primary">
                          削除
                        </Button>
                      </TableCell>
                    ) : (
                      <TableCell></TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </React.Fragment>
    )
  }

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setDialog: (title: string, content: string, okHandler: () => void, ngHandler: () => void) =>
      dispatch(setDialog(title, content, okHandler, ngHandler))
  }
}
const mapStateToProps = (state: ReturnType<typeof store.getState>) => {
  return {
    admin: state.auth
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admins)
